<template>
  <div class="page-box">
    <div class="card-box">
      <div class="area-box">
        <div class="top-box">
          <div class="left-box">
            <van-image class="image" radius="6px" :src="baseData.backgroundImg" fit="cover" />
            <div class="tag">{{ baseData.activityTag | formatActivityTag }}</div>
            <div class="badge-text">活动id：{{ baseData.activityId }}</div>
          </div>
          <div class="right-box">
            <div class="title-box">{{ baseData.activityTitle }}</div>
            <div class="row">
              <span class="key">开始时间：</span>
              <span class="value">{{ baseData.startTime | dateFormat("YYYY-MM-DD") }}</span>
            </div>
            <div class="row">
              <span class="key">结束时间：</span>
              <span class="value">{{ baseData.endTime | dateFormat("YYYY-MM-DD") }}</span>
            </div>
             <div class="row">
              <span class="key">报名费：</span>
              <span class="value orange" v-if="+baseData.signUpfee > 0">¥{{ baseData.signUpfee }}</span>
              <span class="value orange" v-else>免费</span>
            </div>
          </div>
        </div>
       <div class="bottom-box">
          <div class="item" v-if="isTeacher && baseData.activityTag == activityTagEnum.myCreated" @click="inviteStore">邀请门店</div>
          <div class="item" v-if="!isTeacher" @click="redirectTo('poster')">海报分享</div>
          <div class="item" @click="redirectTo('view')">查看活动</div>
        </div>
      </div>
    </div>

    <div class="card-content-lsy" v-if="!isGuide">
      <div class="dealer-title">
        <span>活动数据</span>
        <svg
          class="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 200 200"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-.5,8.5c13,0,63-7,80-7s42,7,70,7c30,0,63-7,84-7s58,7,83,7,58-7,83-7v398H-.5Z"
            />
            <linearGradient id="orange_red" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop
                offset="0%"
                style="stop-color: #fff9f6; stop-opacity: 0.4"
              />
              <stop
                offset="100%"
                style="stop-color: #fff0ea; stop-opacity: 1"
              />
            </linearGradient>
          </defs>
          <g class="parallax">
            <use
              xlink:href="#gentle-wave"
              x="-60"
              y="7"
              fill="url(#orange_red)"
            />
            <use xlink:href="#gentle-wave" x="-40" y="12" fill="#FFF0EA" />
          </g>
        </svg>
        <span class="more-data" @click="redirectTo('activityData')">
          更多数据
          <van-icon name="arrow" />
        </span>
      </div>
      <div class="card-inner">
        <div class="card-text grid-item">
          <div class="orange">{{ statisticsData2.browseNumber }}</div>
          <div class="desc">浏览次数</div>
        </div>
        <div class="card-text grid-item">
          <div class="orange">{{ statisticsData2.browsePeopleNumber }}</div>
          <div class="desc">浏览人数</div>
        </div>
        <div class="card-text grid-item">
          <div class="orange">{{ statisticsData2.shareNumber }}</div>
          <div class="desc">二次分享</div>
        </div>
        <div class="card-text grid-item" @click="redirectTo('userData', 2)">
          <div class="orange">{{ statisticsData2.signUpNumber }}</div>
          <div class="desc" style="color:#ff6b31">报名人数</div>
        </div>
      </div>
    </div>

    <div class="card-content-lsy" v-if="isShowPersonal">
      <div class="dealer-title">
        <span>个人数据</span>
        <svg
          class="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 200 200"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-.5,8.5c13,0,63-7,80-7s42,7,70,7c30,0,63-7,84-7s58,7,83,7,58-7,83-7v398H-.5Z"
            />
            <linearGradient id="orange_red" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop
                offset="0%"
                style="stop-color: #fff9f6; stop-opacity: 0.4"
              />
              <stop
                offset="100%"
                style="stop-color: #fff0ea; stop-opacity: 1"
              />
            </linearGradient>
          </defs>
          <g class="parallax">
            <use
              xlink:href="#gentle-wave"
              x="-60"
              y="7"
              fill="url(#orange_red)"
            />
            <use xlink:href="#gentle-wave" x="-40" y="12" fill="#FFF0EA" />
          </g>
        </svg>
        <span class="more-data" @click="redirectTo('activityData')">
          更多数据
          <van-icon name="arrow" />
        </span>
      </div>
      <div class="card-inner">
        <div class="card-text grid-item">
          <div class="orange">{{ statisticsData3.browseNumber }}</div>
          <div class="desc">浏览次数</div>
        </div>
        <div class="card-text grid-item">
          <div class="orange">{{ statisticsData3.browsePeopleNumber }}</div>
          <div class="desc">浏览人数</div>
        </div>
        <div class="card-text grid-item">
          <div class="orange">{{ statisticsData3.shareNumber }}</div>
          <div class="desc">二次分享</div>
        </div>
        <div class="card-text grid-item" @click="redirectTo('userData', 1)">
          <div class="orange">{{ statisticsData3.signUpNumber }}</div>
          <div class="desc" style="color:#ff6b31">报名人数</div>
        </div>
      </div>
    </div>

    <div class="card-content-lsy" @click="redirectTo('TaskDetails')">
      <div class="dealer-title">
        <span>任务数据</span>
        <svg
          class="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 200 200"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-.5,8.5c13,0,63-7,80-7s42,7,70,7c30,0,63-7,84-7s58,7,83,7,58-7,83-7v398H-.5Z"
            />
            <linearGradient id="orange_red" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop
                offset="0%"
                style="stop-color: #fff9f6; stop-opacity: 0.4"
              />
              <stop
                offset="100%"
                style="stop-color: #fff0ea; stop-opacity: 1"
              />
            </linearGradient>
          </defs>
          <g class="parallax">
            <use
              xlink:href="#gentle-wave"
              x="-60"
              y="7"
              fill="url(#orange_red)"
            />
            <use xlink:href="#gentle-wave" x="-40" y="12" fill="#FFF0EA" />
          </g>
        </svg>
      </div>
      <div class="card-inner">
        <div class="grid-item">
          <div class="orange ft-14">拉新<br />任务</div>
        </div>
        <div class="grid-item" style="margin-left: 15px; margin-right: 15px">
          <van-icon :name="arrowIcon" size="28" />
        </div>
        <div class="card-text grid-item" style="text-align: left">
          <div class="orange">{{ statisticsData.preNewPeopleNumber }}</div>
          <div class="desc">预计拉新（人）</div>
        </div>
        <div class="card-text grid-item" style="text-align: left">
          <div class="orange">
            {{ statisticsData.newPeopleEndedYesterdayNumber }}
          </div>
          <div class="desc">截止昨日拉新（人）</div>
        </div>
      </div>
      <div class="card-inner">
        <div class="grid-item">
          <div class="orange ft-14">报名<br />数据</div>
        </div>
        <div class="grid-item" style="margin-left: 15px; margin-right: 15px">
          <van-icon :name="arrowIcon" size="28" />
        </div>
        <div class="card-text grid-item" style="text-align: left">
          <div class="orange">{{ statisticsData.preSignupNumber }}</div>
          <div class="desc">预计报名（人）</div>
        </div>
        <div class="card-text grid-item" style="text-align: left">
          <div class="orange">
            {{ statisticsData.signupEndedYesterdayNumber }}
          </div>
          <div class="desc">截止昨日报名（人）</div>
        </div>
      </div>
    </div>

    <div class="card-content-lsy" v-if="isShowTask">
      <div class="dealer-title">
        <span>任务进度</span>
        <svg
          class="waves"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 200 200"
          preserveAspectRatio="none"
          shape-rendering="auto"
        >
          <defs>
            <path
              id="gentle-wave"
              d="M-.5,8.5c13,0,63-7,80-7s42,7,70,7c30,0,63-7,84-7s58,7,83,7,58-7,83-7v398H-.5Z"
            />
            <linearGradient id="orange_red" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop
                offset="0%"
                style="stop-color: #fff9f6; stop-opacity: 0.4"
              />
              <stop
                offset="100%"
                style="stop-color: #fff0ea; stop-opacity: 1"
              />
            </linearGradient>
          </defs>
          <g class="parallax">
            <use
              xlink:href="#gentle-wave"
              x="-60"
              y="7"
              fill="url(#orange_red)"
            />
            <use xlink:href="#gentle-wave" x="-40" y="12" fill="#FFF0EA" />
          </g>
        </svg>
      </div>
      <div class="card-inner process" v-if="statisticsData.preNewPeopleNumber > 0">
        <span>拉新数：</span>
        <van-progress :percentage="statisticsData3.newPercent" color="#FF6B31" stroke-width="2" />
        <span>
          <span class="text-orange">{{statisticsData3.browsePeopleNumber || 0}}</span>
          /
          {{statisticsData3.newNum || 0}}
        </span>
      </div>
      <div class="card-inner process" v-if="statisticsData.preSignupNumber > 0">
        <span>报名数：</span>
        <van-progress :percentage="statisticsData3.registPercent" color="#FF6B31" stroke-width="2" />
        <span>
          <span class="text-orange">{{statisticsData3.signUpNumber || 0}}</span>
          /
          {{statisticsData3.registNum || 0}}
        </span>
      </div>
    </div>

    <div class="tab-card" v-if="isShowTabCard">
      <div class="tab-header">
        <div v-if="isShowTab1"
          class="tab-item"
          :class="{ active: activeIndex == 1 }"
          @click="tabClick(1)">
          活动编辑
        </div>
        <div
          class="tab-item"
          :class="{ active: activeIndex == 2 }"
          @click="tabClick(2)">
          活动工具
        </div>
      </div>
      <div class="tab-content">
        <van-grid v-if="activeIndex == 1" :border="false">
          <van-grid-item :icon="tabIcon9" text="编辑" @click="redirectTo('edit')"/>
          <van-grid-item :icon="tabIcon4" text="虚拟数据" v-if="isSigup" @click="showSignUpDialog(1)"/>
          <van-grid-item :icon="tabIcon8" text="任务设置" v-if="isSigup" @click="showSignUpDialog(2)"/>
          <van-grid-item :icon="tabIcon6" text="海报设置" @click="redirectTo('posterConf')"/>
          <van-grid-item :icon="tabIcon1" text="附加活动" @click="redirectTo('additional')"/>
          <!-- <van-grid-item :icon="tabIcon12" text="短信设置" v-if="isSigup && isTeacher" @click="showSignUpDialog(5)"/> -->
        </van-grid>
        <van-grid v-if="activeIndex == 2" :border="false">
          <van-grid-item :icon="tabIcon6" text="海报分享" v-if="isShowPoster" @click="redirectTo('poster')"/>
          <van-grid-item :icon="tabIcon11" text="中奖线索" v-if="isLotteryConfig" @click="redirectTo('winningClue')"/>
          <template v-if="isShowModifyingBtns">
            <van-grid-item :icon="tabIcon5" text="关闭活动" @click="close"/>
            <van-grid-item :icon="tabIcon3" text="活动克隆" @click="showClone"/>
            <van-grid-item :icon="tabIcon2" text="品牌宣传"  @click="showSignUpDialog(3)"/>
            <van-grid-item :icon="tabIcon7" text="参与轮播"  v-if="isSigup"  @click="showSignUpDialog(4)"/>
            <van-grid-item :icon="tabIcon10" text="添加管理员" @click="redirectTo('manager')"/>
            <van-grid-item :icon="tabIcon12" text="抽奖设置" v-if="isLotteryConfig" @click="redirectTo('lottery')"/>
            <van-grid-item :icon="tabIcon13" text="活动充值"  @click="redirectTo('activityRecharge')"/>
            <van-grid-item :icon="tabIcon4" text="秒杀设置" v-if="isSpike" @click="showSignUpDialog(6)"/>
            <van-grid-item :icon="tabIcon8" text="客户列表"  @click="redirectTo('customer')"/>
            <template v-if="isCoupon">
              <van-grid-item :icon="tabIcon15" text="优惠券客户"  @click="redirecCoupon('/customer-list')"/>
              <van-grid-item :icon="tabIcon16" text="优惠券列表"  @click="redirecCoupon('/coupon-list')"/>
            </template>
            <van-grid-item v-if="isLotteryConfig" :icon="tabIcon17" text="抽奖列表"  @click="redirecCoupon('/lottery-list','lottery')"/>
            <van-grid-item v-if="isGroupBuying" :icon="tabIcon18" text="拼团数据"  @click="redirecCoupon('/group-list', 'groupBuying')"/>
            <van-grid-item v-if="isSpike" :icon="tabIcon19" text="秒杀数据"  @click="redirecCoupon('/spike-list','spike')"/>
            <van-grid-item v-if="isDrawLots" :icon="tabIcon20" text="抽签数据"  @click="redirecCoupon('/drawLots-list', 'drawLots')"/>
            <van-grid-item v-if="isQuestion" :icon="tabIcon21" text="问答数据"  @click="redirecCoupon('/question-list','question')"/>
            <van-grid-item v-if="isCountMoney" :icon="tabIcon22" text="红包挑战赛"  @click="redirecCoupon('/countMoney-list','countMoney')"/>
            <van-grid-item v-if="isDistributor || isShopowner" :icon="tabIcon14" text="客资下载"  @click="downLoad"/>
          </template>
        </van-grid>
      </div>
    </div>
    <activity-config-dialog
      v-if="isShowDialog"
      :visible.sync="isShowDialog"
      :action-type="actionType"
      :configData="configData"
      @refresh="onConfigSuccess"
    />
    <clone-activity-dialog 
      v-if="isShowDialogClone"
      :visible.sync="isShowDialogClone"
      :configData="configData"
    />

    <invitation-code 
      v-if="boolShowCodeDialog" 
      :visible.sync="boolShowCodeDialog"
      :invitationData="configData" 
    />
  </div>
</template>

<script>
import moment from "moment";
import timeIcon from "@/assets/icons/card_icon_time@2x.png";
import arrowIcon from "@/assets/icons/card_icon@2x.png";

import tabIcon1 from "@/assets/icons/card_icon_act@2x.png";
import tabIcon2 from "@/assets/icons/card_icon_brand@2x.png";
import tabIcon3 from "@/assets/icons/card_icon_copy@2x.png";
import tabIcon4 from "@/assets/icons/card_icon_data@2x.png";
import tabIcon5 from "@/assets/icons/card_icon_delete@2x.png";
import tabIcon6 from "@/assets/icons/card_icon_pic@2x.png";
import tabIcon7 from "@/assets/icons/card_icon_play@2x.png";
import tabIcon8 from "@/assets/icons/card_icon_task@2x.png";
import tabIcon9 from "@/assets/icons/card_icon_write@2x.png";
import tabIcon10 from "@/assets/icons/list_add.png";
import tabIcon11 from '@/assets/icons/card_icon_zjxs@2x.png';
import tabIcon12 from '@/assets/icons/card_icon_cjsz@2x.png';
import tabIcon13 from '@/assets/icons/card_icon_hdcz@2x.png';
import tabIcon14 from '@/assets/icons/download.png';
import tabIcon15 from '@/assets/icons/coupon_list@2x.png';
import tabIcon16 from '@/assets/icons/coupon@2x.png';
import tabIcon17 from '@/assets/icons/lottery_icon.png';
import tabIcon18 from '@/assets/icons/group@2x.png';
import tabIcon19 from '@/assets/icons/answer@2x.png'; 
import tabIcon20 from '@/assets/icons/lots_icon.png'; 
import tabIcon21 from '@/assets/icons/spike_icon.png';
import tabIcon22 from '@/assets/icons/red_icon.png';

import activityConfigDialog from "@/pages/activity-management/components/activity-config-pop";
import cloneActivityDialog from "@/pages/activity-management/components/clone-activity-dialog";
import InvitationCode from '@/pages/activity-home/components/invitation-code'
import { mapGetters } from 'vuex'
import {activityTagEnum} from '@/utils/constant'
export default {
  components: {
    activityConfigDialog,
    cloneActivityDialog,
    InvitationCode,
  },
  data() {
    return {
      activityTagEnum,
      timeIcon: timeIcon,
      arrowIcon: arrowIcon,
      tabIcon1: tabIcon1,
      tabIcon2: tabIcon2,
      tabIcon3: tabIcon3,
      tabIcon4: tabIcon4,
      tabIcon5: tabIcon5,
      tabIcon6: tabIcon6,
      tabIcon7: tabIcon7,
      tabIcon8: tabIcon8,
      tabIcon9: tabIcon9,
      tabIcon10,
      tabIcon11,
      tabIcon12,
      tabIcon13,
      tabIcon14,
      tabIcon15,
      tabIcon16,
      tabIcon17,
      tabIcon18,
      tabIcon19,
      tabIcon20,
      tabIcon21,
      tabIcon22,

      activeIndex: 1,
      statisticsData: {},
      statisticsData2: {},
      statisticsData3: {
        newNum: 0,
        registNum: 0,
        newPercent: 0,
        registPercent: 0
      },
      baseData: {},

      isShowDialog: false,
      configData: {},
      actionType: 1,
      activityInfo: {},
      activityConfig: {},

      isShowDialogClone: false,
      boolShowCodeDialog: false,
      isClick: true
      
    };
  },
  computed: {
    ...mapGetters({
      // 经销商
      isDistributor: 'isDistributor',
      // 店长
      isShopowner: 'isShopowner',
      // 导购
      isGuide: 'isGuide',
      // 活动老师
      isTeacher: 'isTeacher',
      userInfo: 'userInfo'
    }),
    // 是否显示整个tab
    isShowTabCard() {
      // 查询回来了活动信息
      const activityReady = this.baseData && Object.keys(this.baseData).length > 0;
      // 活动老师+管理员：没有任何按钮
      const hideTab = this.isTeacher && this.baseData.activityTag == activityTagEnum.manager;
      return activityReady && !hideTab;
    },
    // 是否显示活动编辑
    // 活动工具：显示tab时，总会显示
    isShowTab1() {
      return this.baseData.activityTag == activityTagEnum.myCreated;
    },
    // 是否显示个人数据
    isShowPersonal() {
      // 活动老师没有，其他角色都有
      return !this.isTeacher;
    },
    // 是否显示任务进度
    isShowTask() {
      // 活动老师没有
      if (this.isTeacher || !this.statisticsData) {
        return false;
      }
      // 其他角色至少配置一个
      return this.statisticsData.preSignupNumber > 0 || this.statisticsData.preNewPeopleNumber > 0;
    },
    // 是否显示任务数据，活动数据
    isShowData() {
      // 创建人和管理员显示
      return [activityTagEnum.myCreated, activityTagEnum.manager].includes(+this.baseData.activityTag);
    },
    // 是否显示海报分享按钮
    isShowPoster() {
      // 活动老师没有，红包挑战赛特殊角色或其他角色都有
      return !this.isTeacher || this.userInfo.countAuthority;
    },
    // 是否显示关闭活动、活动克隆、品牌宣传、参与轮播
    isShowModifyingBtns() {
      if (this.isGuide) {
        return false;
      }

      return this.baseData.activityTag == activityTagEnum.myCreated;
    },
    // 是否显示抽奖设置按钮
    isLotteryConfig() {
      return this.activityInfo.activityModule && this.activityInfo.activityModule.some(item => item.moduleType =='lottery')
    },
    // 是否有报名组件
    isSigup() {
      return this.activityInfo.activityModule && this.activityInfo.activityModule.some(item => item.moduleType =='sign-up')
    },
    // 是否有直播组件
    isReserve() {
      return this.activityInfo.activityModule && this.activityInfo.activityModule.some(item => item.moduleType =='live-reserve')
    },
    // 是否有答题组件
    isQuestion() {
      return this.activityInfo.activityModule && this.activityInfo.activityModule.some(item => item.moduleType =='question')
    },
    // 是否有秒杀组件
    isSpike() {
      return this.activityInfo.activityModule && this.activityInfo.activityModule.some(item => item.moduleType =='spike')
    },
    // 是否有优惠券组件
    isCoupon() {
      return this.activityInfo.activityModule && this.activityInfo.activityModule.some(item => item.moduleType =='coupon')
    },
    // 是否有拼团组件
    isGroupBuying() {
      return this.activityInfo.activityModule && this.activityInfo.activityModule.some(item => item.moduleType =='groupBuying')
    },
    // 是否有抽签组件
    isDrawLots() {
      return this.activityInfo.activityModule && this.activityInfo.activityModule.some(item => item.moduleType =='drawLots')
    },
    // 是否有红包挑战赛
    isCountMoney() {
      return this.activityInfo.activityModule && this.activityInfo.activityModule.some(item => item.moduleType =='countMoney')
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    tabClick(index) {
      this.activeIndex = index;
    },
    async init() {
      const activityId = this.$route.query.activityId;
      this.getActivityBaseInfo(activityId);
      // 先查询活动信息，用于修改活动和计算拉新报名进度
      await this.getActivityInfoById(activityId);
      // 任务数据
      this.getMissionData(activityId);
      // 活动数据
      this.getStatisticData(activityId);
    },
    getActivityInfoById(activityId) {
      activityId = activityId || this.$route.query.activityId;
      return this.$api.activityMgmt.getActivityInfoById(activityId)
      .then(({data}) => {
        this.activityInfo = data;
        this.activityConfig = this.getActivityConfig(data.activityConfig || [])
      })
      .catch(console.log);
    },
    getActivityConfig(activityConfig) {
      let obj = {}
      activityConfig.forEach(item => {
        obj[item.configCode] = item.configValue
      })
      return obj
    },
    getActivityBaseInfo(activityId) {
      return this.$api.h5.activitySimpleData(activityId)
        .then((res) => {
          this.baseData = res.data || {};
          if(!this.isShowTab1) {
            this.activeIndex = 2;
          }
        });
    },
    getMissionData(activityId) {
      return this.$api.h5
        .getActivityMissionData(activityId)
        .then((res) => {
          this.statisticsData = res.data;
        });
    },
    getStatisticData(activityId) {
      this.$api.h5.getActivityStatistic(activityId)
        .then((res) => {
          this.statisticsData2 = res.data;
        });

      this.$api.h5.getActivityStatisticByUserId(activityId, this.userInfo.id)
        .then(({data}) => {
          if (!data) {
            return;
          }
          // 任务拉新数
          let newNum = 0;
          // 任务报名数
          let registNum = 0
          let keys = []
          if (this.isDistributor) {
            keys = ['newNumCustomer', 'registNumCustomer']
          }else if (this.isShopowner) {
            keys = ['newNumStore', 'registNumStore']
          }else if (this.isGuide) {
            keys = ['newNumEmployee', 'registNumEmployee']
          }
          if (this.activityInfo && this.activityInfo.activityModule) {
            const signUpModule = this.activityInfo.activityModule
              .find(item => item.moduleType === 'sign-up');
            if (signUpModule && signUpModule.activityModuleSetup) {
              signUpModule.activityModuleSetup.forEach(item => {
                if (item.setupColumn === keys[0]) {
                  newNum = +item.setupColumnValue || 0;
                } 
                if (item.setupColumn === keys[1]) {
                  registNum = +item.setupColumnValue || 0;
                }
              })
            }
          }
          
          // 拉新数进度
          const newPercent = newNum > 0 
            ? Math.floor(data.browsePeopleNumber / newNum * 100)
            : 0;
          // 报名数进度
          const registPercent = registNum > 0
            ? Math.floor(data.signUpNumber / registNum * 100)
            : 0;
          this.statisticsData3 = {
            ...data,
            newNum,
            registNum,
            newPercent: Math.min(newPercent, 100),
            registPercent: Math.min(registPercent, 100),
          };
        });
    },
    showSignUpDialog(type) {
      this.actionType = type

      let configData = {};
      // 秒杀
      if (type == 6) {
         const signUpConfData = this.activityInfo && this.activityInfo.activityModule.find(item => item.moduleType === 'spike');
          configData = {
            moduleId: signUpConfData.moduleId,
            moduleItems: signUpConfData.activityModuleSetup || []
          };
      } else {
        if (type != 3) {
          const signUpConfData = this.activityInfo && this.activityInfo.activityModule.find(item => item.moduleType === 'sign-up');
          if (signUpConfData) {
            configData = {
              moduleId: signUpConfData.moduleId,
              moduleItems: signUpConfData.activityModuleSetup || []
            };
          } 
        } else {
          // 品牌介绍配置
          configData = {
            activityId: this.activityInfo.activityId,
            moduleItems: this.activityInfo.activityConfig || []
          };
        }
      }
      this.configData = configData;
      if (this.activityInfo.status != 3) {
        this.isShowDialog = true;
      }else {
        this.$toast('当前活动已经结束，无法操作');
      }
    },
    onConfigSuccess() {
      this.init();
    },
    redirectTo(pathType, extType) {
      const pathMap = {
        view: '/activity-home',
        edit: '/activity/edit-basic',
        posterConf: '/activity/poster',
        poster: '/activity/promotion-poster',
        additional: '/activity/additional',
        manager: '/manager-list',
        activityData: '/activity-data',
        userData: '/user',
        TaskDetails: '/task-details',
        winningClue: '/winning-clue',
        lottery: '/lottery-config',
        activityRecharge: '/activity-recharge',
        customer: "/customer-list"
      };
      let query = {
        activityId: this.activityInfo.activityId,
        activityTag: this.baseData.activityTag,
        from: 'manager'
      };
      const {createWay = '', tmpType = '1'} = this.activityConfig
      if (pathType === 'edit') {
        if (createWay == 'new') {
          pathMap.edit = '/newActivity/create',
          query.creationMode = createWay
          query.tmpType = tmpType
        }
        query.activeTab = this.$route.query.activeTab;
      }
      
      if (pathType === 'view') {
        query.tmpType = tmpType
      }

      if (pathType === 'additional' || pathType === 'activityRecharge') {
        query.activityStatus = this.baseData.status;
      }

      if (['userData', 'activityData'].includes(pathType)) {
        delete query.activityTag
      }

      if (pathType === 'userData') {
        // extType 1:个人数据  2：活动数据
        const statistics = extType === 1 ? this.statisticsData3 : this.statisticsData2;
        query = {
          ...query,
          enterType: statistics.enterType,
          enterPrimaryKey: statistics.enterPrimaryKey
        }
      }

      if (pathType === 'TaskDetails') {
        query = {
          activityId: this.activityInfo.activityId,
          enterPrimaryKey: this.statisticsData.enterPrimaryKey,
          enterType: this.statisticsData.enterType,
        }
      }

      if (pathType === 'lottery') {
        query.isSigup = this.isSigup
        query.isReserve = this.isReserve
      }
      let isContain = ['activityData','userData','view','TaskDetails','additional', 'activityRecharge','winningClue','customer'].includes(pathType)
      if (this.activityInfo.status != 3  || isContain ) {
        this.$router.push({
          path: pathMap[pathType],
          query
        })
      }else {
        this.$toast('当前活动已经结束，无法操作');
      }
    },
    redirecCoupon(path,cmpName) {
      const currentCmpInfo = this.getCmpInfo(cmpName)
      this.$router.push({
        path: path,
        query: {
          moduleId: currentCmpInfo.moduleId,
          activityId: this.activityInfo.activityId,
        }
      })
    },
    getCmpInfo(cmpName) {
      const currentCmpInfo =  this.activityInfo.activityModule.find(item => item.moduleType == cmpName)
      return currentCmpInfo
    },
    downLoad() {
      if (this.isClick){
      this.isClick = false
      this.$api.activityMgmt
        .dataExport({type: 7,activityId:this.$route.query.activityId })
        .then((res) => {
          if (res.success) {
            this.$dialog.confirm({
              title: '下载提示',
              message:`因数据较大正在处理中，请稍后到<br/>我的-导出列表中下载数据`,
              cancelButtonText: '确定',
              confirmButtonText: '去往-导出列表'
            }).then(_ =>{
              this.$router.push({
                path: '/export-list'
              })
            })
          }
        }).finally(_ => {
          setTimeout(() => {
            this.isClick = true
          },500)
        })
      } 
    },
    showClone() {
      const {createWay = '', tmpType = '1'} = this.activityConfig
      this.configData = {
        activityId: this.activityInfo.activityId,
        creationMode: createWay,
        tmpType
      };
      
      // // 是否新组件创建方式
      // if (this.activityInfo.activityConfig.some(item => item.configValue == 'new')) {
      //   this.configData.creationMode = 'new'
      // }
      this.isShowDialogClone = true;
    },
    // 邀请门店
    inviteStore() {
      const {activityId, activityTitle, startTime, endTime} = this.activityInfo;
      this.configData = {
        activityId,
        activityTitle, 
        startTime, 
        endTime,
        inviteeId: this.userInfo.id,
        invitee: this.userInfo.realName,
        signUpFee: this.baseData.signUpfee,
      };
      this.boolShowCodeDialog = true;
    },
    close() {
      if (this.activityInfo.status != 3) {
        this.$funcDialog.show({
          content: '请问是否关闭当前活动？<br />关闭后将不可恢复！'
        });
        this.$funcDialog.addEventListener(status=>{
          if(status == 'cancel') return;
          this.$api.h5.closeActivity(this.activityInfo.activityId)
          .then(_ => {
            this.$router.push('/home');
          })
        });
      }else {
        this.$toast('当前活动已经结束，无法操作');
      }
    },
  },
  filters: {
    dateFormat(val, patern = "YYYY-MM-DD HH:mm:ss") {
      return moment(val).format(patern);
    },
    formatActivityTag(val) {
      const map = {
        1: '我创建',
        2: '经销商',
        3: '活动老师',
        4: '活动管理员',
      };
      return map[val];
    },
    statusEnum(val) {
      const map = {
        0: '草稿',
        1: '待开始',
        2: '进行中',
        3: '已结束',
      };
      return map[val];
    }
  },
};
</script>

<style lang="stylus" scoped>
.page-box {
  background: #fff;
  .card-box {
    width: 100%;
    border-radius: 0px 0px 12px 12px;
    background: linear-gradient( 90deg, #FF8231 0%, #FF6B59 100%);
    padding: 12px;
    box-sizing: border-box;
    .area-box {
      border-radius: 8px;
      background: #fff;
      .top-box {
        display: flex;
        padding: 10px 10px 0 10px;
        .left-box {
          position: relative;
          width: 100px;
          height: 100px;
          .image {
            width: 100px;
            height: 100px;
          }
          .tag {
            position: absolute;
            left: 0;
            top: 0;
            height: 20px;
            line-height: 20px;
            font-size: 12px;
            color: #fff;
            padding: 0 6px;
            border-radius: 10px 0px 10px 0px;
            border: 1px solid #FF734B;
            background: #FF6B31;
          }
          .badge-text {
            position: absolute;
            bottom: 0;
            left: 0;
            right: 0;
            height: 18px;
            line-height: 18px;
            padding: 0 6px;
            background: rgba(0,0,0,0.3);
            border-radius: 0px 0px 6px 6px;
            color: #FFFFFF;
            font-size: 10px;
            text-align: center;
          }
        }
        .right-box {
          flex: 1;
          margin-left: 10px;
          margin-top: 2px;
          .title-box {
            color: #333333;
            font-size: 15px;
            font-weight: bold;
            margin: 0px 0 16px 0;
          }
          .row {
            display flex;
            font-size: 14px; 
            margin-top: 6px;
            .key {
              color: #999999;
            }
            .value {
              color: #666666;
            }
            .orange {
              color: #FF6B31;
            }
          }
        }
      }
      .bottom-box {
        display: flex;
        align-items: center;
        margin-top: 17px;
        height: 34px;
        background: #FFF7F4;
        border-bottom-left-radius: 8px;
        border-bottom-right-radius: 8px;
        .item {
          flex: 1;
          text-align center
          line-height: 13px;
          color: #FF6B31;
          font-size: 14px;
          border-right: 1px solid #999999;
          &:last-child {
            border-right: none;
          }
        }
      } 
    }
  }
}
.card-content-lsy {
  .dealer-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .more-data {
      font-weight 200
      color #666666
    }
  }
}

.price {
  color: #FF6B31;
  font-size: 14px;
}

.text-orange {
  color: #FF6B31;
}

.time-icon {
  margin-right: 3px;
  position: relative;
  top: 1px;
}

.process
  font-size 13px
  color #666666
  >>> .van-progress
    flex 1
    margin 0 20px
    .van-progress__pivot
      display none

.ft-14 {
  font-size: 14px !important;
  font-weight: normal !important;
}

.tab-card {
  margin: 15px;
  background: #ffffff;
  border-radius: 5px;
  overflow: hidden;
  position: relative;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.1);

  .tab-header {
    height: 40px;
    background: #FFF0EA;
    display: flex;
    align-items: center;

    .tab-item {
      color: rgba(255, 107, 49, 0.6);
      flex: 1;
      width: 0;
      height: inherit;
      text-align: center;
      line-height: 40px;
    }

    .tab-item:first-child.active {
      background: #ffffff;
      border-radius: 0 15px 0 0;
      color: #FF6B31;
    }

    .tab-item:nth-child(2).active {
      background: #ffffff;
      border-radius: 15px 0 0 0;
      color: #FF6B31;
    }

    .tab-content {
      position: relative;
    }
  }
}

.role-tag {
  position: absolute;
  right: 0;
  top: 0;
  z-index: 999;
  background: linear-gradient(0deg, #FF8820 0%, #FF6B31 100%);
  color: rgba(255, 255, 255, 0.8);
  border-radius: 0px 5px 0px 8px;
  font-size: 12px;
  border: 1px solid #FEE5B0;
  padding: 2px 6px;
  box-shadow: 0 0 5px 5px rgba(0, 0, 0, 0.5);
}
</style>